import { observeLazyImages, observeLazyBackgrounds } from '@rover/utilities/lazyImageObserver';

window.util = window.util || {};

window.util.lazyImageLoader = {
  observeLazy() {
    observeLazyImages(document.querySelectorAll('img.js-lazy'));
    observeLazyBackgrounds(document.querySelectorAll('div.js-lazy-background'));
  },
};



// WEBPACK FOOTER //
// ../utilities/lazyImageLoader.js